/* unplugin-vue-components disabled */import script from "./webLayout2.vue?vue&type=script&lang=ts&setup=true"
export * from "./webLayout2.vue?vue&type=script&lang=ts&setup=true"

import "./webLayout2.vue?vue&type=style&index=0&id=5a2dbeb8&scoped=true&lang=less"

import exportComponent from "D:\\workspace\\home-power-station\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a2dbeb8"]])

export default __exports__